export function getRecipeIds(dayMenuId, state) {
  const dayMenu = state.menu.dayMenus.find(item => item.id === dayMenuId);

  const recipeIds = dayMenu.main? [dayMenu.main.id] : [];
  const sideRecipeIds = dayMenu.sides.map(side => side.id);
  return recipeIds.concat(sideRecipeIds);
}
